import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Certificazioni from "@/pages/Certificazioni";
import Lavori from "@/pages/Lavori";
import Contatti from "@/pages/Contatti";
import Admin from "@/pages/Admin";
import InquiryPage from "@/pages/InquiryPage";
import Bim from "@/pages/Bim";
import { LanguageProvider } from "@/i18n/LanguageContext";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import LegalPage from "@/pages/LegalPage";
import { PageViewTracker } from "@/components/PageViewTracker";
import { PageTransition } from "@/components/PageTransition";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      {isAdmin && <div data-testid="admin-language-bar" className="flex justify-end bg-[#F8FAFC] px-4 py-2"><LanguageSwitcher /></div>}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chi-siamo" element={<ChiSiamo />} />
        <Route path="/certificazioni" element={<Certificazioni />} />
        <Route path="/bim" element={<Bim />} />
        <Route path="/lavori" element={<Lavori />} />
        <Route path="/contatti" element={<Contatti />} />
        <Route path="/preventivo" element={<InquiryPage key="quote" kind="quote" />} />
        <Route path="/lavora-con-noi" element={<InquiryPage key="career" kind="career" />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/privacy" element={<LegalPage kind="privacy" />} />
        <Route path="/cookie" element={<LegalPage kind="cookie" />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <ChatWidget />}
    </>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
        <SiteProvider>
          <ScrollManager />
          <PageViewTracker />
          <PageTransition />
          <Shell />
          <Toaster position="top-center" richColors />
        </SiteProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}
